export const HEATMAP_HORIZONTAL_PADDING = 18
export const HEATMAP_TOP_PADDING = 16
export const HEATMAP_BOTTOM_PADDING = 44
export const HEATMAP_LEFT_PADDING = 68
export const LEGEND_WIDTH_PX = 120
export const LEGEND_HEIGHT_PX = 260
export const SECTION_LINE_COLOR = 'rgba(79, 79, 79, 0.9)'
export const WELD_LINE_COLOR = 'rgba(93, 93, 93, 0.85)'
export const FEATURE_OUTLINE_COLOR = 'rgba(30, 30, 30, 0.9)'
export const LABEL_BACKGROUND = 'rgba(255, 255, 255, 0.82)'
export const LABEL_TEXT_COLOR = '#2f2f2f'
export const LABEL_EDGE_PADDING_PX = 5
